import React from 'react';

type NewsType = {

}

export const News = (props: NewsType) => {
	return (
		<>
			<div>В стадии наполнения</div>
		</>
	);
};